/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForAssessmentRun extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForAssessmentRun");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForAssessmentRun.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForAssessmentRun>): BackgroundJobPayloadForAssessmentRun {
        let obj = Object.assign(new BackgroundJobPayloadForAssessmentRun(), model);
        BackgroundJobPayloadForAssessmentRun.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForAssessmentRun>): BackgroundJobPayloadForAssessmentRun {
        if (!model) return null;
        return BackgroundJobPayloadForAssessmentRun.newInstance(<BackgroundJobPayloadForAssessmentRun> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForAssessmentRun) {
        if (!obj) return;

        models.BackgroundJobPayloadForAssessmentRun.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForAssessmentRun): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForAssessmentRun.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.contexts) {
            for (let val of this.contexts) {
                models.WellArchitectedFrameworkAssessmentContext.fixupPrototype(val);
            }
        }
    }

    /**
     * State of the background job
     */
    state: models.BackgroundJobPayloadForAssessmentRunState;

    /**
     * The assessment run history for this scan
     */
    assessment_run_history_id: string;

    /**
     * Context triggering this background job
     */
    contexts: Array<models.WellArchitectedFrameworkAssessmentContext>;

    /**
     * States if the assessment is full scan or not
     */
    is_rescan: boolean;

    report_ids: Array<string>;

}
